import React from 'react';
import { showETA, getStatusColor } from '../Helper';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { COMPLETED, WITHDRAWN, PENDING } from '../../../constants';

const XBRLDetails = (props) => {
    return (
        <table className="table table-bordered border-bottom-0 case-about-table">
            <tbody>
                <tr>
                    <th className="header-blue" width="30%">File Name (Last Updated)</th>
                    <td className="text-truncate">{(props.xbrlDetails) ? <span className='xbrl-name' onClick={(event) => props.downloadXbrlCallback(event, props.xbrlDetails.xbrlFileS3Key)}> {props.xbrlDetails.xbrlFileS3Key}</span> : ''} {(props.userDetails.scopes[0] === "ROLE_RUBIXADMIN" && props.xbrlDetails.xbrlFileS3Key) ? <Link to={`/xbrlmasterkeys/edit`} >edit</Link> : null}</td>
                </tr>
                <tr>
                    <th width="30%" className="header-blue">Upload</th>
                    <td title={props.metadata.counterpartyName} className="text-truncate" >
                        {/* <div color="primary" className="btn btn-primary ml-3 position-relative" title="Upload New Risk Factor"> */}
                        {/* <div> */}
                        <input onChange={props.uploadxbrlFileCallback} type="file" name="file" id="file" className="" title="Upload New XBRL" disabled={(props.metadata.status === COMPLETED || props.metadata.status === WITHDRAWN) ? true : false} />
                        {/* <i className="fa fa-upload"></i> */}
                        {/* </div> */}
                    </td>
                </tr>
                <tr>
                    <th width="30%" className="header-blue">Status</th>
                    <td className={getStatusColor(props.xbrlDetails.status)}> {(props.xbrlDetails) ? props.xbrlDetails.status : ''}</td>
                </tr>
                <tr>
                    <th width="30%" className="header-blue">Created on</th>
                    <td> {(props.xbrlDetails) ? showETA(props.xbrlDetails.updatedAt) : ''} </td>
                </tr>
                <tr>
                    <th width="30%" className="header-blue">Rerun Processing</th>
                    <td> <Button color='primary' disabled={(props.xbrlDetails) ? (props.xbrlDetails.status === PENDING || props.xbrlDetails.status === 'PROCESSING') ? false : false : false} className='btn btn-primary' onClick={() => props.rerunProcessingCallback(props.xbrlDetails.id)}>Rerun</Button></td>
                </tr>
                {/* <tr>
                    <th width="30%" className="header-blue">Due date</th>
                    <td> {showETA(props.metadata.dueDate)} </td>
                </tr>
                <tr>
                    <th width="30%" className="header-blue">Status</th>
                    <td> {props.metadata.status}{props.viewPublishedReport}
                        {(props.metadata.status === constants.WITHDRAWN) ? < WithdrawnReasonPopover withdrawnReason={props.metadata.withdrawalReason} /> : ''}
                    </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Allocated to</th>
                    <td title={props.metadata.assignedTo} className="text-truncate"> {props.metadata.assignedTo} </td>
                </tr> */}
            </tbody>
        </table >
    )
}

export default XBRLDetails